import {
  MDBBadge,
  MDBBtn,
  MDBBtnGroup,
  MDBCheckbox,
  MDBChip,
  MDBDatatable,
  MDBDropdown,
  MDBDropdownItem,
  MDBDropdownMenu,
  MDBDropdownToggle,
  MDBIcon,
  MDBInput,
  MDBModalFooter,
  MDBPopconfirm,
  MDBPopconfirmMessage,
  MDBSpinner
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Tooltip } from "react-tooltip";
import { getGlobalLocationList, getPhoneNumsByType, setGlobalLocationFilter } from "../../apiclients/streamsapi_bridge";
import PopupLoader from "../../views/popups/PopupLoader";
import { formattedNumber, unFormatNumber } from "../../views/popups/phonenumbers/AddRemoveNumbers";
import UnassignPhoneNumbers from "../../views/popups/phonenumbers/UnassignPHNumbers";
import PHChangeLocation from "../../views/popups/phonenumbers/PHChangeLocation";
import { customSearch, useAutoFocusSearchAfterLoads } from "../CustomSearchUtil/CustomSearch";
import UIConstant from "../../apiclients/UIConstant";
import TabIDConstant from "../../apiclients/TabIDConstant";

export default function AssignPHNumber(props) {
  const [assignNumbers, setAssignedNumbers] = useState([]);
  const [isloading, setIsloading] = useState(true);
  const [unassignPHNum, SetUnassignPHNum] = useState(false);
  const [selectedPHNum, setSelectedPHNum] = useState([]);
  const [reRender, setreRender] = useState(true);
  const [smsFilterList, setsmsFilterList] = useState([]);
  const [assignedFilterList, setassignedFilterList] = useState([]);
  const [stateFilterList, setstateFilterList] = useState([]);
  const [locationFilterList, setlocationFilterList] = useState([]);
  const [selectedSMS, setselectedSMS] = useState("");
  const [selectedAssigned, setselectedAssigned] = useState("");
  const [selectedStates, setselectedStates] = useState("");
  const [selectedLocation, setselectedLocation] = useState("");
  const [selectedSMSIds, setselectedSMSIds] = useState([]);
  const [selectedAssignedIds, setselectedAssignedIds] = useState([]);
  const [selectedLocationIds, setselectedLocationIds] = useState([]);
  const [selectedStatesIds, setselectedStatesIds] = useState([]);
  const [existSelectedSMS, setexistSelectedSMS] = useState([]);
  const [existSelectedAssigned, setexistSelectedAssigned] = useState([]);
  const [existSelectedStates, setexistSelectedStates] = useState([]);
  const [existSelectedLocation, setexistSelectedLocation] = useState([]);
  const [newSeletcedList, setnewSeletcedList] = useState([]);
  const [selectedNewLocationIds, setselectedNewLocationIds] = useState([]);
  const [existSelectedNewLocationIds, setexistSelectedNewLocationIds] = useState([]);
  const [selectedNewStatesIds, setselectedNewStatesIds] = useState([]);
  const [existSelectedNewStatesIds, setexistSelectedNewStatesIds] = useState([]);
  const [selectedNewSMSIds, setselectedNewSMSIds] = useState([]);
  const [existSelectedNewSMSIds, setexistSelectedNewSMSIds] = useState([]);
  const [selectedNewAssignedIds, setselectedNewAssignedIds] = useState([]);
  const [existSelectedNewAssignedIds, setexistSelectedNewAssignedIds] = useState([]);
  const [displayFilterLocations, setdisplayFilterLocations] = useState([]);
  const [displayNewFilterLocations, setdisplayNewFilterLocations] = useState([]);
  const [displayFilterStates, setdisplayFilterStates] = useState([]);
  const [displayNewFilterStates, setdisplayNewFilterStates] = useState([]);
  const [allLocation, setallLocation] = useState(false);
  const [allStates, setallStates] = useState(false);
  const [allNewLocation, setallNewLocation] = useState(false);
  const [allNewStates, setallNewStates] = useState(false);
  const [displayFilterSMS, setdisplayFilterSMS] = useState([]);
  const [displayNewFilterSMS, setdisplayNewFilterSMS] = useState([]);
  const [displayFilterAssigned, setdisplayFilterAssigned] = useState([]);
  const [displayNewFilterAssigned, setdisplayNewFilterAssigned] = useState([]);
  const [allSMS, setallSMS] = useState(false);
  const [allAssigned, setallAssigned] = useState(false);
  const [allNewSMS, setallNewSMS] = useState(false);
  const [allNewAssigned, setallNewAssigned] = useState(false);
  const [searchMainValue, setsearchMainValue] = useState("");
  const [searchEditValue, setsearchEditValue] = useState("");
  const [searchMainStateValue, setsearchMainStateValue] = useState("");
  const [searchEditStateValue, setsearchEditStateValue] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const [assignPhNumDetails, setAssignPhNumDetails] = useState([]);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [dataLoaded, setDataLoaded] = useState(false);
  const searchRef = useRef(null);

  const [nineoonum, setnineoonum] = useState(false)

  const [allChecked, setallChecked] = useState(false);
  const [phNumList, setphNumList] = useState([]);
  const [disableChangeLocation, setdisableChangeLocation] = useState(true);
  const [rowdata, setRowData] = useState([]);
  const [showChangeLocation, setshowChangeLocation] = useState(false);
  const toggleChangeLocation = () => setshowChangeLocation(!showChangeLocation);

  useAutoFocusSearchAfterLoads(dataLoaded, setDataLoaded, searchRef, props.isActive)
  const utogglePopup = () => {
    SetUnassignPHNum(!unassignPHNum)
    setnineoonum(false)
  };

  const handleAllChecked = (isChecked) => {
    if (isChecked) {
      setallChecked(true);
      const nums = [];
      filteredRows.forEach((row) => {
        nums.push(row.phnumInfo.phnumber + "");
      });
      setphNumList(nums);
      setdisableChangeLocation(false);
    } else {
      setallChecked(false);
      setphNumList([]);
      setdisableChangeLocation(true);
    }
  };

  function handleCheckedRow(e, phnum) {
    let phnumber = phnum.phnumber + "";
    let updatedNums;
    if (e.target.checked) {
      updatedNums = [...phNumList, phnumber];
    } else {
      updatedNums = phNumList.filter((n) => n !== phnumber);
    }
    const allSelected =
      filteredRows.length > 0
        ? filteredRows.every((row) => updatedNums.includes(row.phnumInfo.phnumber + ""))
        : false;
    setallChecked(allSelected);
    setdisableChangeLocation(updatedNums.length === 0);
    setphNumList(updatedNums);
  }

  function showThisInf(tdata) {
    navigate("/phonenumberdetails", {
      state: tdata.phnumInfo,
    });

  }

  function unassignPhoneNumber(evntData, phno, assignto) {
    console.log(` phonenumber assignto  ::::: ${assignto}`)
    if (assignto == 911) {
      console.log("condition trueee:::")
      setnineoonum(true)
    }
    evntData.preventDefault();
    evntData.stopPropagation();
    let selPhone = assignNumbers.filter((tmdata) => tmdata.phnumber == phno).map((tmdata) => tmdata.phnumber);;
    SetUnassignPHNum(true);
    setSelectedPHNum(selPhone);
  }



  async function fetchData() {
    sessionStorage.setItem("current_link", "phonenumbers");
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getPhoneNumsByType(1, JSON.parse(sessionStorage.getItem("admin_session")).siteid, TabIDConstant.ASSIGNED_PH_NUM_SUBLINK);
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const rawData = await response.json();
    if (!rawData) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("response data is :::::::::: " + rawData);
    console.log("response data is ::::::::::1 " + JSON.stringify(rawData))
    if (props.setIsSmsEnabled) {
      props.setIsSmsEnabled(rawData?.is_sms_enabled);
    }
    setAssignedNumbers(rawData?.ph_numbers?.assigned_phnum ?? []);
    setTimeout(() => {
      setIsloading(false);
    }, 1000);
  }

  useEffect(() => {
    let processdrows = [];
    assignNumbers.map((phnum) => {
      console.log("phonenumber objects ::::", JSON.stringify(phnum))
      let phNumber = phnum.phnumber ? formattedNumber(phnum.phnumber) + "" : ""
      processdrows.push({
        phnumInfo: { ...phnum, assigned: true },
        checkBoxValue: (<MDBCheckbox checked={phNumList.includes(phnum.phnumber + "")} onClick={(e) => handleCheckedRow(e, phnum)} />),
        phnumber: phNumber,
        smsEnabled: phnum.smsenabled ? (
          <MDBIcon fas icon="check" className="ms-4 ps-1 primary checked-icon" />
          // <MDBBadge color="primary" title="SMS Capable" className="fw-400"><MDBIcon far icon="comment-alt" className="ms-2 fs-14px"/></MDBBadge>
        ) : <>
          <h6 class="no-red ms-4">No</h6>
        </>,
        actualNumber: phNumber?.toString().replace(/[ ]/g, ''),
        state: phnum.state + "",
        assignedto: phnum.assignedto + "",
        assignedname: (phnum.assignedname ? phnum.assignedname : "") + "",
        location_name: phnum?.location_name ? phnum?.location_name : "",
        unassign: (
          <>
            {/* <a className="ms-4"
            style={{ zIndex: 99996 }}
            href="#"
            onClick={(e) => unassignPhoneNumber(e, `${phnum.phnumber}`)}
            target="_new"
          >
            <MDBIcon fas icon="times" color="primary" title="Unassign" />
          </a> */}

            <div className="d-flex align-items-center justify-content-center">
              <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) => unassignPhoneNumber(e, `${phnum.phnumber}`, phnum.assignedto)}>
                <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
              </div>
            </div>
          </>
        ),

      })
    })
    setRowData(processdrows);
    setFilteredRows(processdrows);
    setAssignPhNumDetails(processdrows)
    setDataLoaded(true)
  }, [assignNumbers])

  useEffect(() => {
    setFilteredRows(filteredRows.map((row) => ({
      ...row,
      checkBoxValue: (
        <MDBCheckbox
          checked={phNumList.includes(row.phnumInfo.phnumber + "")}
          onClick={(e) => handleCheckedRow(e, row.phnumInfo)}
        />
      ),
    })));
  }, [phNumList]);

  useEffect(() => {
    if (reRender) {
      getPhoneFilter();
      setreRender(false);
    }

  }, [reRender]);



  async function getPhoneFilter() {
    try {
      const adminSession = sessionStorage.getItem("admin_session");
      const siteid = JSON.parse(adminSession).siteid;
      let response;
      const extracondition = `?module_type=6`;
      response = await getGlobalLocationList(siteid, extracondition);
      if (!response.json) {
        const message = `An error has occured: ${response.statusText}`;
        return;
      }
      let rawData = await response.json();
      console.log("Global user filter ::::::::: " + JSON.stringify(rawData));
      if (!rawData) {
        window.alert(`info with id  not found`);
        // navigate("/");
      }
      let sms = (rawData?.result?.sms ?? []);
      sms = getSmsStatusArray(sms);
      const location = rawData?.result?.locations ?? [];
      const states = rawData?.result?.states ?? [];
      const assignedto = rawData?.result?.assignedto ?? [];
      setTheStateValues(sms, location, states, assignedto);

    } catch (error) {

    }

  }

  function setTheStateValues(sms, location, states, assignedto) {
    let smsSelected = sms.filter(sms => sms.selected).map(sms => sms.entity_name).join(', ');
    const smsSelectedids = sms.some(sms => sms.entity_id === -1 && sms.selected)
      ? sms.map(sms => sms.entity_id)
      : sms.filter(sms => sms.selected).map(sms => sms.entity_id);
    const smsindex = smsSelectedids.findIndex(id => id === -1);
    if (smsindex !== -1) {
      smsSelectedids.splice(smsindex, 1);
      smsSelected = "";
      setselectedNewSMSIds(smsSelectedids);
      setexistSelectedNewSMSIds(smsSelectedids);
      setallNewSMS(true);
    }

    let locationSelected = location.filter(loc => loc.selected).map(loc => loc.entity_name).join(', ');
    const locationSelectedids = location.some(loc => loc.entity_id === -1 && loc.selected)
      ? location.map(loc => loc.entity_id)
      : location.filter(loc => loc.selected).map(loc => loc.entity_id);

    const index = locationSelectedids.findIndex(id => id === -1);
    if (index !== -1) {
      locationSelectedids.splice(index, 1);
      locationSelected = "";
      setselectedNewLocationIds(locationSelectedids);
      setexistSelectedNewLocationIds(locationSelectedids);
      setallNewLocation(true);
    }

    let statesSelected = states.filter(state => state.selected).map(state => state.entity_name).join(', ');
    const statesSelectedids = states.some(state => state.entity_id === -1 && state.selected)
      ? states.map(state => state.entity_id)
      : states.filter(state => state.selected).map(state => state.entity_id);

    const stateindex = statesSelectedids.findIndex(id => id === -1);
    if (stateindex !== -1) {
      statesSelectedids.splice(stateindex, 1);
      statesSelected = "";
      setselectedNewStatesIds(statesSelectedids);
      setexistSelectedNewStatesIds(statesSelectedids);
      setallNewStates(true);
    }


    let assignSelected = assignedto.filter(assign => assign.selected).map(assign => assign.entity_name).join(', ');
    const assignSelectedids = assignedto.some(assign => assign.entity_id === -1 && assign.selected)
      ? assignedto.map(assign => assign.entity_id)
      : assignedto.filter(assign => assign.selected).map(assign => assign.entity_id);

    const assindex = assignSelectedids.findIndex(id => id === -1);
    if (assindex !== -1) {
      assignSelectedids.splice(assindex, 1);
      assignSelected = "";
      setselectedNewAssignedIds(assignSelectedids);
      setexistSelectedNewAssignedIds(assignSelectedids);
      setallNewAssigned(true);
    }
    const newusersmsFilter = sms.filter((sms) => parseInt(sms.entity_id) !== -1);
    setsmsFilterList(newusersmsFilter);
    setdisplayFilterSMS(newusersmsFilter);
    setdisplayNewFilterSMS(newusersmsFilter);

    const newuserLocationsFilter = location.filter((loc) => parseInt(loc.entity_id) !== -1);
    setlocationFilterList(newuserLocationsFilter);
    setdisplayFilterLocations(newuserLocationsFilter);
    setdisplayNewFilterLocations(newuserLocationsFilter);

    const newuserassignFilter = assignedto.filter((loc) => parseInt(loc.entity_id) !== -1);
    setassignedFilterList(newuserassignFilter);
    setdisplayFilterAssigned(newuserassignFilter);
    setdisplayNewFilterAssigned(newuserassignFilter);


    const newuserstateFilter = states.filter((loc) => parseInt(loc.entity_id) !== -1);
    setstateFilterList(newuserstateFilter)
    setdisplayFilterStates(newuserstateFilter);
    setdisplayNewFilterStates(newuserstateFilter);

    if (smsSelected && smsSelected !== "") {
      setselectedSMS(`${t("SMS")} : ${smsSelected}`);
      setselectedSMSIds(smsSelectedids);
      setexistSelectedSMS(smsSelectedids);
    }
    if (locationSelected && locationSelected !== "") {
      setselectedLocation(`${t("Location")} : ${locationSelected}`);
      setselectedLocationIds(locationSelectedids);
      setexistSelectedLocation(locationSelectedids);
    }
    if (statesSelected && statesSelected !== "") {
      setselectedStates(`${t("State")} : ${statesSelected}`);
      setselectedStatesIds(statesSelectedids);
      setexistSelectedStates(statesSelectedids);
    }
    if (assignSelected && assignSelected !== "") {
      setselectedAssigned(`${t("Assigned To")} : ${assignSelected}`);
      setselectedAssignedIds(assignSelectedids);
      setexistSelectedAssigned(assignSelectedids);
    }

  }

  const getSmsStatusArray = (sms = []) => {
    return [
      ...(sms.includes(-1)
        ? [{
          entity_id: -1,
          entity_name: "Select All",
          selected: true,
        }]
        : []),
      {
        entity_id: 1,
        entity_name: "Enabled",
        selected: sms.includes(1),
      },
      {
        entity_id: 0,
        entity_name: "Disabled",
        selected: sms.includes(0),
      },
    ];
  };


  const basicData = {
    columns: [
      {
        label: (
          <MDBCheckbox
            checked={allChecked}
            onChange={(e) => handleAllChecked(e.target.checked)}
          />
        ),
        field: "checkBoxValue",
        sort: false,
      },
      { label: "Phone Number(s)", field: "phnumber", sort: true },
      // {label:"",field:"smsEnabled",sort:false},
      // { label: "SMS Enabled", field: "smsEnabled", sort: false },
      { label: "State ", field: "state" },
      // { label: "Area Code " },
      { label: "Assigned to ", field: "assignedto" },
      { label: "Name ", field: "assignedname" },
      { label: "Location", field: "location_name" },
      { label: "Unassign ", field: "unassign", sort: false },
    ],
    rows: assignPhNumDetails,
  };

  const handleManualSearch = (searchValue) => {
    setSearchValue(searchValue);
    const filtered = customSearch(assignPhNumDetails, searchValue, UIConstant.ASSIGN_PHONE_NUMBER);

    setFilteredRows(filtered);
  };

  // Fetching the data for display
  useEffect(() => {
    if (props.isActive) {
      fetchData();
    }
  }, [props.isActive]);



  const [addFilter, setAddFilter] = useState(false);
  const [showSMS, setShowSMS] = useState(false);
  const [showLocation, setshowLocation] = useState(false);
  const [showStates, setshowStates] = useState(false);
  const [showAssigned, setshowAssigned] = useState(false)
  const [showFilterDetail, setShowFilterDetail] = useState('');

  const toggleSMS = (event) => {
    event.preventDefault()
    event.stopPropagation()
    setnewSeletcedList([]);
    setShowSMS(!showSMS);
    setshowLocation(false); // Ensure other div is hidden
    setshowStates(false); // Ensure other div is hidden
    setshowAssigned(false); // Ensure other div is hidden
  };

  const toggleLocation = (event) => {
    event.preventDefault()
    event.stopPropagation()
    setshowLocation(!showLocation);
    setnewSeletcedList([]);
    setShowSMS(false); // Ensure other div is hidden
    setshowStates(false); // Ensure other div is hidden
    setshowAssigned(false); // Ensure other div is hidden
  };

  const toggleState = (event) => {
    event.preventDefault()
    event.stopPropagation()
    setshowStates(!showStates);
    setnewSeletcedList([]);
    setshowLocation(false); // Ensure other div is hidden
    setShowSMS(false); // Ensure other div is hidden
    setshowAssigned(false); // Ensure other div is hidden
  };

  const toggleAssigned = (event) => {
    event.preventDefault()
    event.stopPropagation()
    setshowAssigned(!showAssigned);
    setnewSeletcedList([]);
    setShowSMS(false); // Ensure other div is hidden
    setshowLocation(false); // Ensure other div is hidden
    setshowStates(false); // Ensure other div is hidden
  };

  const toggleBackClick = (event) => {
    event.preventDefault()
    event.stopPropagation()
    setShowSMS(false); // Ensure other div is hidden
    setshowLocation(false); // Ensure other div is hidden
    setshowStates(false); // Ensure other div is hidden
    setshowAssigned(false); // Ensure other div is hidden
  }



  const handleSubmit = async (event, filterKey, selectValue) => {
    event.preventDefault();
    console.log("value of selected filters are ::::: " + JSON.stringify(selectValue));
    const adminSession = sessionStorage.getItem("admin_session");
    const siteid = JSON.parse(adminSession).siteid;
    let update = {
      reqid: 62,
      siteid: siteid,
      filter_value: selectValue,
      filter_type: 1,
      filter_key: parseInt(filterKey),
      module_type: 6,
    }

    console.log("Modify location filter value  :::: " + JSON.stringify(update));
    let saverep = await setGlobalLocationFilter(update);
    console.log(`reponse of Edit user :::: ${JSON.stringify(saverep)}`);
    let saverepeMsg = await saverep.json();
    console.log(
      "response of modified data :::" + JSON.stringify(saverepeMsg)
    );
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      localStorage.setItem("s_message", saverepeMsg.message);
    }
    else {
      localStorage.setItem("f_message", saverepeMsg.message);
    }
    navigate("/phonenumbers", {
      state: { tab: "tab1" },
    });
    window.location.reload();
  }

  const removeallfilters = (value) => {
    removeThisFilter(-1);
  }

  const handleDeleteSMSFilters = (value) => {
    removeThisFilter(8);
  }
  const handleDeleteLocationFilters = (value) => {
    removeThisFilter(12);
  }
  const handleDeleteStateFilters = (value) => {
    removeThisFilter(10);
  }
  const handleDeleteAssignedFilters = (value) => {
    removeThisFilter(9);
  }

  async function removeThisFilter(filterKey) {
    const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
    console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
    setIsloading(true);
    let update = {
      reqid: 62,
      siteid: siteid,
      filter_value: [-1],
      filter_type: 1,
      filter_key: filterKey ? parseInt(filterKey) : -1,
      module_type: 6,
    }
    console.log("Modify User filter value  :::: " + JSON.stringify(update));
    let deleteFilter = await setGlobalLocationFilter(update);;
    setTimeout(() => {
      setIsloading(false);
    }, 1000);
    let deleteMsg = await deleteFilter.json();
    console.log("Response... ");
    console.log(deleteMsg);
    if (deleteMsg.status == "Failed") {
      localStorage.setItem(
        "user_create_f",
        "Something went wrong, Please try again after sometime"
      );
      // props.onClose();
    } else {
      localStorage.setItem("s_message", deleteMsg.message);

    }
    navigate("/phonenumbers", {
      state: { tab: "tab1" },
    });
    window.location.reload();
  }

  function cancelFilterChanges(flag) {
    if (flag === 8) {
      setselectedSMSIds(existSelectedSMS);
      if (existSelectedSMS.length === smsFilterList.length || existSelectedSMS.length === displayFilterSMS.length) {
        setallSMS(true);
      } else {
        setallSMS(false);
      }
    } else if (flag === 12) {
      setselectedLocationIds(existSelectedLocation);
      if (existSelectedLocation.length === locationFilterList.length || existSelectedLocation.length === displayFilterLocations.length) {
        setallLocation(true);
      } else {
        setallLocation(false);
      }
    } else if (flag === 10) {
      setselectedStatesIds(existSelectedStates);
      if (existSelectedStates.length === stateFilterList.length || existSelectedStates.length === displayFilterStates.length) {
        setallStates(true);
      } else {
        setallStates(false);
      }
    } else if (flag === 9) {
      setselectedAssignedIds(existSelectedAssigned);
      if (existSelectedAssigned.length === assignedFilterList.length || existSelectedAssigned.length === displayFilterAssigned.length) {
        setallAssigned(true);
      } else {
        setallAssigned(false);
      }
    } else {
      if (flag === 15) {
        if (existSelectedNewLocationIds.length === locationFilterList.length || existSelectedNewLocationIds.length === displayFilterLocations.length) {
          setallNewLocation(true);
        } else {
          setallNewLocation(false);
        }
        setselectedNewLocationIds(existSelectedNewLocationIds);

      } else if (flag === 16) {
        if (existSelectedNewStatesIds.length === stateFilterList.length || existSelectedNewStatesIds.length === displayFilterStates.length) {
          setallNewLocation(true);
        } else {
          setallNewLocation(false);
        }
        setselectedNewStatesIds(existSelectedNewStatesIds);
      } else if (flag === 17) {
        if (existSelectedNewSMSIds.length === smsFilterList.length || existSelectedNewSMSIds.length === displayFilterSMS.length) {
          setallNewSMS(true);
        } else {
          setallNewSMS(false);
        }
        setselectedNewSMSIds(existSelectedNewSMSIds);
      } else {
        if (existSelectedNewAssignedIds.length === assignedFilterList.length || existSelectedNewAssignedIds.length === displayFilterAssigned.length) {
          setallNewAssigned(true);
        } else {
          setallNewAssigned(false);
        }
        setselectedNewAssignedIds(existSelectedNewAssignedIds);
      }
    }
  }

  function handleSearch(e, flag) {
    const value = e.target.value;
    // const regex = new RegExp(`\\b${value.toLowerCase()}`, "i");
    if (flag === 1) {
      setsearchMainValue(value);
      setdisplayFilterLocations(customSearch(locationFilterList, value, ['entity_name']));
    } else if (flag === 2) {
      setsearchMainStateValue(value);
      setdisplayFilterStates(customSearch(stateFilterList, value, ['entity_name']));
    } else if (flag === 3) {
      setsearchEditValue(value);
      setdisplayNewFilterLocations(customSearch(locationFilterList, value, ['entity_name']));
    } else {
      setsearchEditStateValue(value);
      setdisplayNewFilterStates(customSearch(stateFilterList, value, ['entity_name']));
    }
  }

  const handleNewCheckboxChange = (value, filterid) => {
    let updatedValues = [];

    if (filterid === 12) {
      updatedValues = [...selectedNewLocationIds];
      if (updatedValues.includes(value)) {
        // If already selected, remove it
        updatedValues.splice(updatedValues.indexOf(value), 1);
      } else {
        // If not selected, add it
        updatedValues.push(value);
      }
      if (updatedValues.length !== displayNewFilterLocations.length) {
        setallNewLocation(false);
      } else {
        const tempArray = displayNewFilterLocations.map(loc => loc.entity_id);
        const sortedArr1 = [...tempArray].sort();
        const sortedArr2 = [...updatedValues].sort();

        // Compare each element
        for (let i = 0; i < sortedArr1.length; i++) {
          if (sortedArr1[i] !== sortedArr2[i]) {
            setallNewLocation(false);
            break;
          }
        }
        setallNewLocation(true);
      }
      setselectedNewLocationIds(updatedValues);

    } else if (filterid === 10) {
      updatedValues = [...selectedNewStatesIds];

      if (updatedValues.includes(value)) {
        // If already selected, remove it
        updatedValues.splice(updatedValues.indexOf(value), 1);
      } else {
        // If not selected, add it
        updatedValues.push(value);
      }
      if (updatedValues.length !== displayNewFilterStates.length) {
        setallNewStates(false);
      } else {
        const tempArray = displayNewFilterStates.map(state => state.entity_id);
        const sortedArr1 = [...tempArray].sort();
        const sortedArr2 = [...updatedValues].sort();

        // Compare each element
        for (let i = 0; i < sortedArr1.length; i++) {
          if (sortedArr1[i] !== sortedArr2[i]) {
            setallNewStates(false);
            break;
          }
        }
        setallNewStates(true);
      }

      setselectedNewStatesIds(updatedValues);

    } else if (filterid === 8) {
      updatedValues = [...selectedNewSMSIds];

      if (updatedValues.includes(value)) {
        // If already selected, remove it
        updatedValues.splice(updatedValues.indexOf(value), 1);
      } else {
        // If not selected, add it
        updatedValues.push(value);
      }
      if (updatedValues.length !== displayNewFilterSMS.length) {
        setallNewSMS(false);
      } else {
        const tempArray = displayNewFilterSMS.map(sms => sms.entity_id);
        const sortedArr1 = [...tempArray].sort();
        const sortedArr2 = [...updatedValues].sort();

        // Compare each element
        for (let i = 0; i < sortedArr1.length; i++) {
          if (sortedArr1[i] !== sortedArr2[i]) {
            setallNewSMS(false);
            break;
          }
        }
        setallNewSMS(true);
      }

      setselectedNewSMSIds(updatedValues);

    } else {
      updatedValues = [...selectedNewAssignedIds];

      if (updatedValues.includes(value)) {
        // If already selected, remove it
        updatedValues.splice(updatedValues.indexOf(value), 1);
      } else {
        // If not selected, add it
        updatedValues.push(value);
      }
      if (updatedValues.length !== displayNewFilterAssigned.length) {
        setallNewAssigned(false);
      } else {
        const tempArray = displayNewFilterAssigned.map(assign => assign.entity_id);
        const sortedArr1 = [...tempArray].sort();
        const sortedArr2 = [...updatedValues].sort();

        // Compare each element
        for (let i = 0; i < sortedArr1.length; i++) {
          if (sortedArr1[i] !== sortedArr2[i]) {
            setallNewAssigned(false);
            break;
          }
        }
        setallNewAssigned(true);
      }

      setselectedNewAssignedIds(updatedValues);
    }


  };

  const disableFilter = () => {
    setShowSMS(false); // Ensure other div is hidden
    setshowLocation(false); // Ensure other div is hidden
    setshowStates(false); // Ensure other div is hidden
    setshowAssigned(false); // Ensure other div is hidden
  }

  function isArraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    // Sort both arrays
    const sortedArr1 = [...arr1].sort();
    const sortedArr2 = [...arr2].sort();

    // Compare each element
    for (let i = 0; i < sortedArr1.length; i++) {
      if (sortedArr1[i] !== sortedArr2[i]) {
        return false;
      }
    }

    return true;

  }

  const handleSMSCheckboxChange = (value) => {
    const updatedValues = [...selectedSMSIds];
    if (updatedValues.includes(value)) {
      // If already selected, remove it
      updatedValues.splice(updatedValues.indexOf(value), 1);
    } else {
      // If not selected, add it
      updatedValues.push(value);
    }
    if (updatedValues.length !== displayFilterSMS.length) {
      setallSMS(false);
    } else {
      const tempArray = displayFilterSMS.map(sms => sms.entity_id);
      const sortedArr1 = [...tempArray].sort();
      const sortedArr2 = [...updatedValues].sort();

      // Compare each element
      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
          setallSMS(false);
          break;
        }
      }
      setallSMS(true);
    }

    setselectedSMSIds(updatedValues);
  };
  const handleLocationCheckboxChange = (value) => {
    const updatedValues = [...selectedLocationIds];
    if (updatedValues.includes(value)) {
      // If already selected, remove it
      updatedValues.splice(updatedValues.indexOf(value), 1);
    } else {
      // If not selected, add it
      updatedValues.push(value);
    }
    if (updatedValues.length !== displayFilterLocations.length) {
      setallLocation(false);
    } else {
      const tempArray = displayFilterLocations.map(loc => loc.entity_id);
      const sortedArr1 = [...tempArray].sort();
      const sortedArr2 = [...updatedValues].sort();

      // Compare each element
      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
          setallLocation(false);
          break;
        }
      }
      setallLocation(true);
    }

    setselectedLocationIds(updatedValues);
  };
  const handleStateCheckboxChange = (value) => {
    const updatedValues = [...selectedStatesIds];
    if (updatedValues.includes(value)) {
      // If already selected, remove it
      updatedValues.splice(updatedValues.indexOf(value), 1);
    } else {
      // If not selected, add it
      updatedValues.push(value);
    }
    if (updatedValues.length !== displayFilterStates.length) {
      setallStates(false);
    } else {
      const tempArray = displayFilterStates.map(state => state.entity_id);
      const sortedArr1 = [...tempArray].sort();
      const sortedArr2 = [...updatedValues].sort();

      // Compare each element
      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
          setallStates(false);
          break;
        }
      }
      setallStates(true);
    }

    setselectedStatesIds(updatedValues);
  };

  function handleAllLocation(e) {
    // e.preventDefault();
    setallLocation(e.target.checked);
    if (e.target.checked) {
      const locId = displayFilterLocations.map(loc => loc.entity_id);
      setselectedLocationIds(locId);
    } else {
      setselectedLocationIds([]);
    }

  }

  function handleAllSMS(e) {
    // e.preventDefault();
    setallSMS(e.target.checked);
    if (e.target.checked) {
      const locId = displayFilterSMS.map(sms => sms.entity_id);
      setselectedSMSIds(locId);
    } else {
      setselectedSMSIds([]);
    }

  }

  function handleAllAssigned(e) {
    // e.preventDefault();
    setallAssigned(e.target.checked);
    if (e.target.checked) {
      const locId = displayFilterAssigned.map(assign => assign.entity_id);
      setselectedAssignedIds(locId);
    } else {
      setselectedAssignedIds([]);
    }

  }

  function handleAllStates(e) {
    // e.preventDefault();
    setallStates(e.target.checked);
    if (e.target.checked) {
      const stateId = displayFilterStates.map(state => state.entity_id);
      setselectedStatesIds(stateId);
    } else {
      setselectedStatesIds([]);
    }

  }

  function handleNewAllLocation(e) {
    // e.preventDefault();
    setallNewLocation(e.target.checked);
    if (e.target.checked) {
      const locId = displayNewFilterLocations.map(loc => loc.entity_id);
      setselectedNewLocationIds(locId);
    } else {
      setselectedNewLocationIds([]);
    }

  }
  function handleNewAllSMS(e) {
    // e.preventDefault();
    setallNewSMS(e.target.checked);
    if (e.target.checked) {
      const locId = displayNewFilterSMS.map(loc => loc.entity_id);
      setselectedNewSMSIds(locId);
    } else {
      setselectedNewSMSIds([]);
    }

  }
  function handleNewAllAssigned(e) {
    // e.preventDefault();
    setallNewAssigned(e.target.checked);
    if (e.target.checked) {
      const locId = displayNewFilterAssigned.map(loc => loc.entity_id);
      setselectedNewAssignedIds(locId);
    } else {
      setselectedNewAssignedIds([]);
    }

  }
  function handleNewAllStates(e) {
    // e.preventDefault();
    setallNewStates(e.target.checked);
    if (e.target.checked) {
      const locId = displayNewFilterStates.map(state => state.entity_id);
      setselectedNewStatesIds(locId);
    } else {
      setselectedNewStatesIds([]);
    }
  }

  const handleAssignedCheckboxChange = (value) => {
    const updatedValues = [...selectedAssignedIds];
    if (updatedValues.includes(value)) {
      // If already selected, remove it
      updatedValues.splice(updatedValues.indexOf(value), 1);
    } else {
      // If not selected, add it
      updatedValues.push(value);
    }


    if (updatedValues.length !== displayFilterAssigned.length) {
      setallAssigned(false);
    } else {
      const tempArray = displayFilterAssigned.map(assign => assign.entity_id);
      const sortedArr1 = [...tempArray].sort();
      const sortedArr2 = [...updatedValues].sort();

      // Compare each element
      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
          setallAssigned(false);
          break;
        }
      }
      setallAssigned(true);
    }

    setselectedAssignedIds(updatedValues);
  };


  // useEffect(() => {
  //   const patchTitles = () => {
  //     const tds = document.querySelectorAll('table td');
  //     tds.forEach(td => {
  //       if (!td.getAttribute('title')) {
  //         td.setAttribute('title', td.textContent.trim());
  //       }
  //     });
  //   };

  //   // Patch immediately, then again slightly later
  //   patchTitles();
  //   const timer = setTimeout(patchTitles, 100);

  //   return () => clearTimeout(timer);
  // }, [basicData]);

  return (
    <>
      {/* {isloading && (
        <>
          <div className="loadingclass">
            <MDBSpinner className="ms-2" color="primary">
              <span className="visually-hidden">Loading...</span>
            </MDBSpinner>
          </div>
        </>

      )} */}
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
      {/* <p className="mb-2">
        <strong>{t('Note')}: </strong>
        {t('assignNote')}
      </p> */}
      <div className="w-100 phonenumbersDatatable">
        <div className="position-absolute left__341px d-flex align-items-center" style={{ left: "340px" }}>
          {selectedSMS && (
            <>
              <div className="ms-4 popconfirmFilter">
                <MDBPopconfirm className="p-0 w-auto" color='light' placement='bottom-start' rippleRadius={10} btnChildren={<>

                  <MDBChip className="m-0" onClick={(e) => { e.preventDefault(); }}>
                    <div className="filterElliipse">
                      {selectedSMS}
                    </div>
                    <MDBIcon fas icon="times" className="ms-2 fs-6" onClick={(e) => { e.stopPropagation(); handleDeleteSMSFilters() }} />
                  </MDBChip>

                </>}>

                  <MDBPopconfirmMessage>
                    <div className="fw-500">
                      SMS
                    </div>
                    <div className="filter-border"></div>
                    <div className="ps-2 pb-2">
                      <div className="mt-3">
                        <MDBCheckbox checked={allSMS} onChange={(e) => handleAllSMS(e)} label="Select All" />
                      </div>
                      {displayFilterSMS && displayFilterSMS.map((sms) => (
                        <div className="" key={sms.entity_id}>
                          <MDBCheckbox name='flexCheck' value={sms.entity_id} id={sms.entity_id} label={sms.entity_name} checked={selectedSMSIds.includes(sms.entity_id)}
                            onChange={() => handleSMSCheckboxChange(sms.entity_id)}
                          />
                        </div>
                      ))}

                      <div className="filter-border"></div>
                      <div className="d-flex float-end mt-3">
                        {(selectedSMSIds.length > 0 && !isArraysEqual(selectedSMSIds, existSelectedSMS)) && (
                          <>
                            <MDBBtn size="sm" color="secondary" onClick={(e) => cancelFilterChanges(8)}>Cancel</MDBBtn>

                            <MDBBtn size="sm" className="ms-2" onClick={(e) => {
                              handleSubmit(e, 8, (selectedSMSIds.length === smsFilterList.length) ? [-1] : selectedSMSIds);
                            }}>Apply</MDBBtn>
                          </>
                        )}

                      </div>
                    </div>
                  </MDBPopconfirmMessage>
                </MDBPopconfirm>
              </div>
            </>
          )}
          {selectedLocation && (
            <div className="mx-3 popconfirmFilter">
              <MDBPopconfirm className="p-0 w-auto" color='light' placement='bottom-start' rippleRadius={10} btnChildren={<>
                <MDBChip className="m-0" onClick={(e) => e.preventDefault()}>
                  <div className="filterElliipse">
                    {selectedLocation}
                  </div>
                  <MDBIcon fas icon="times" className="ms-2 fs-6" onClick={(e) => { e.stopPropagation(); handleDeleteLocationFilters() }} />
                </MDBChip>
              </>}>
                <MDBPopconfirmMessage>
                  <div className="fw-500">
                    Location
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="w-100">
                      <MDBInput placeholder="search" value={searchMainValue} onChange={(e) => handleSearch(e, 1)} />
                    </div>
                  </div>
                  <div className="filter-border"></div>
                  <div className="ps-2 pb-2 filtersScroll">
                    <div className="mt-3">
                      <MDBCheckbox checked={allLocation} onChange={(e) => handleAllLocation(e)} label="Select All" />
                    </div>
                    <div>
                      {displayFilterLocations && displayFilterLocations.map((loc) => (
                        <div className="" key={loc.entity_id}>
                          <MDBCheckbox name='flexCheck2' value={loc.entity_id} id={loc.entity_id} label={loc.entity_name} checked={selectedLocationIds.includes(loc.entity_id)}
                            onChange={() => handleLocationCheckboxChange(loc.entity_id)}
                          />
                        </div>
                      ))}

                    </div>
                    <div className="filter-border"></div>
                  </div>
                  <div className="d-flex float-end mt-3">
                    {(selectedLocationIds.length > 0 && !isArraysEqual(selectedLocationIds, existSelectedLocation)) && (
                      <>
                        <MDBBtn size="sm" onClick={(e) => {
                          handleSubmit(e, 12, (selectedLocationIds.length === locationFilterList.length) ? [-1] : selectedLocationIds);
                        }}> Apply</MDBBtn>

                        <MDBBtn size="sm" color="secondary" className="ms-2" onClick={(_e) => cancelFilterChanges(12)}>Cancel</MDBBtn>
                      </>
                    )}
                  </div>
                </MDBPopconfirmMessage>
              </MDBPopconfirm>
            </div>
          )}
          {selectedStates && (
            <div className="mx-3 popconfirmFilter">
              <MDBPopconfirm className="p-0 w-auto" color='light' placement='bottom-start' rippleRadius={10} btnChildren={<>
                <MDBChip className="m-0" onClick={(e) => e.preventDefault()}>
                  <div className="filterElliipse">
                    {selectedStates}
                  </div>
                  <MDBIcon fas icon="times" className="ms-2 fs-6" onClick={(e) => { e.stopPropagation(); handleDeleteStateFilters() }} />
                </MDBChip>
              </>}>
                <MDBPopconfirmMessage>
                  <div className="fw-500">
                    State
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="w-100">
                      <MDBInput placeholder="search" value={searchMainStateValue} onChange={(e) => handleSearch(e, 2)} />
                    </div>
                  </div>
                  <div className="filter-border"></div>
                  <div className="ps-2 pb-2 filtersScroll">
                    <div className="mt-3">
                      <MDBCheckbox checked={allStates} onChange={(e) => handleAllStates(e)} label="Select All" />
                    </div>
                    <div>
                      {displayFilterStates && displayFilterStates.map((state) => (
                        <div className="" key={state.entity_id}>
                          <MDBCheckbox name='flexCheck2' value={state.entity_id} id={state.entity_id} label={state.entity_name} checked={selectedStatesIds.includes(state.entity_id)}
                            onChange={() => handleStateCheckboxChange(state.entity_id)}
                          />
                        </div>
                      ))}

                    </div>
                  </div>
                  <div className="filter-border"></div>
                  <div className="d-flex float-end mt-3">
                    {(selectedStatesIds.length > 0 && !isArraysEqual(selectedStatesIds, existSelectedStates)) && (
                      <>
                        <MDBBtn size="sm" onClick={(e) => {

                          handleSubmit(e, 10, (selectedStatesIds.length === stateFilterList.length) ? [-1] : selectedStatesIds);
                        }}> Apply</MDBBtn>

                        <MDBBtn size="sm" color="secondary" className="ms-2" onClick={(e) => cancelFilterChanges(10)}>Cancel</MDBBtn>
                      </>
                    )}
                  </div>
                </MDBPopconfirmMessage>
              </MDBPopconfirm>
            </div>
          )}
          {selectedAssigned && (
            <div className="mx-3 popconfirmFilter">
              <MDBPopconfirm className="p-0 w-auto" color='light' placement='bottom-start' rippleRadius={10} btnChildren={<>
                <MDBChip className="m-0" onClick={(e) => e.preventDefault()}>
                  <div className="filterElliipse">
                    {selectedAssigned}
                  </div>
                  <MDBIcon fas icon="times" className="ms-2 fs-6" onClick={(e) => { e.stopPropagation(); handleDeleteAssignedFilters() }} />
                </MDBChip>
              </>}>
                <MDBPopconfirmMessage>
                  <div className="fw-500">
                    Assign To
                  </div>
                  <div className="filter-border"></div>
                  <div className="ps-2 pb-2 filtersScroll">
                    <div className="mt-3">
                      <MDBCheckbox checked={allSMS} onChange={(e) => handleAllAssigned(e)} label="Select All" />
                    </div>
                    <div>
                      {displayFilterAssigned && displayFilterAssigned.map((assign) => (
                        <div className="" key={assign.entity_id}>
                          <MDBCheckbox name='flexCheck2' value={assign.entity_id} id={assign.entity_id} label={assign.entity_name} checked={selectedAssignedIds.includes(assign.entity_id)}
                            onChange={() => handleAssignedCheckboxChange(assign.entity_id)}
                          />
                        </div>
                      ))}

                    </div>
                  </div>
                  <div className="filter-border"></div>
                  <div className="d-flex float-end mt-3">
                    {(selectedAssignedIds.length > 0 && !isArraysEqual(selectedAssignedIds, existSelectedAssigned)) && (
                      <>
                        <MDBBtn size="sm" onClick={(e) => {
                          handleSubmit(e, 9, (selectedAssignedIds.length === assignedFilterList.length) ? [-1] : selectedAssignedIds);
                        }}> Apply</MDBBtn>

                        <MDBBtn size="sm" color="secondary" className="ms-2" onClick={(e) => cancelFilterChanges(9)}>Cancel</MDBBtn>
                      </>
                    )}
                  </div>
                </MDBPopconfirmMessage>
              </MDBPopconfirm>
            </div>
          )}
          {!(selectedSMS && selectedLocation && selectedStates && selectedAssigned) && (
            <div className="">

              <MDBPopconfirm placement='bottom-start' onClick={disableFilter} className="shadow-4-strong"
                btnChildren={<><MDBIcon fas icon="filter" className="me-2" /> {t("addFilter")}</>}>
                <MDBPopconfirmMessage className="p-2">
                  <div>
                    <p className='mb-3 fw-600 filterhead'>
                      {(showSMS || showLocation || showStates || showAssigned) ? (showSMS ? "SMS" : showLocation ? "Location" : showStates ? "State" : "Assigned To") : "Filter by"}
                    </p>

                    {!showSMS && !showLocation && !showStates && !showAssigned && (
                      <>
                        {/* <div className={"d-flex flex-column " + (selectedSMS !== "" ? "cursor-disabled" : "")}>
                          <div className={"cursor-pointer " + (selectedSMS !== "" ? "Filter_disabled" : "")} onClick={toggleSMS}>
                            SMS
                          </div>
                        </div> */}
                        <div className={"d-flex flex-column " + (selectedLocation !== "" ? "cursor-disabled" : "")}>
                          <div className={"cursor-pointer " + (selectedLocation !== "" ? "Filter_disabled" : "")} onClick={toggleLocation}>
                            Location
                          </div>
                        </div>
                        <div className={"d-flex flex-column mt-2 " + (selectedStates !== "" ? "cursor-disabled" : "")}>
                          <div className={"cursor-pointer mt-2 " + (selectedStates !== "" ? "Filter_disabled" : "")} onClick={toggleState}>
                            State
                          </div>
                        </div>

                        <div className={"d-flex flex-column mt-2 " + (selectedAssigned !== "" ? "cursor-disabled" : "")}>
                          <div className={"cursor-pointer mt-2 " + (selectedAssigned !== "" ? "Filter_disabled" : "")} onClick={toggleAssigned}>
                            Assigned to
                          </div>
                        </div>
                      </>
                    )}

                    {showSMS && (
                      <>
                        <div className="mt-3">
                          <MDBCheckbox checked={allNewSMS} onChange={(e) => handleNewAllSMS(e)} label="Select All" />
                        </div>
                        <div className="filtersScroll">
                          {displayNewFilterSMS && displayNewFilterSMS.map((sms) => (
                            <div className="" key={sms.entity_id}>
                              <MDBCheckbox name='flexCheck' value={sms.entity_id} id={sms.entity_id} label={sms.entity_name} checked={selectedNewSMSIds.includes(sms.entity_id)}
                                onChange={() => handleNewCheckboxChange(sms.entity_id, 8)}
                              />
                            </div>
                          ))}
                        </div>
                      </>
                    )}

                    {showLocation && (
                      <>
                        <div className="d-flex align-items-center">
                          <div className="w-100">
                            <MDBInput autoFocus placeholder="search" value={searchEditValue} onChange={(e) => handleSearch(e, 3)} />
                          </div>
                        </div>
                        <div className="filter-border py-2"></div>
                        <div className="mt-3">
                          <MDBCheckbox checked={allNewLocation} onChange={(e) => handleNewAllLocation(e)} label="Select All" />
                        </div>
                        <div className="filtersScroll">

                          {displayNewFilterLocations && displayNewFilterLocations.map((loc) => (
                            <div className="" key={loc.entity_id}>
                              <MDBCheckbox name='flexCheck' value={loc.entity_id} id={loc.entity_id} label={loc.entity_name} checked={selectedNewLocationIds.includes(loc.entity_id)}
                                onChange={() => handleNewCheckboxChange(loc.entity_id, 12)}
                              />
                            </div>
                          ))}
                        </div>
                      </>

                    )}

                    {showStates && (
                      <>
                        <div className="d-flex align-items-center">
                          <div className="w-100">
                            <MDBInput autoFocus placeholder="search" value={searchEditStateValue} onChange={(e) => handleSearch(e, 4)} />
                          </div>
                        </div>
                        <div className="filter-border py-2"></div>
                        <div className="mt-3">
                          <MDBCheckbox checked={allNewStates} onChange={(e) => handleNewAllStates(e)} label="Select All" />
                        </div>
                        <div className="filtersScroll">
                          {displayNewFilterStates && displayNewFilterStates.map((state) => (
                            <div className="" key={state.entity_id}>
                              <MDBCheckbox name='flexCheck' value={state.entity_id} id={state.entity_id} label={state.entity_name} checked={selectedNewStatesIds.includes(state.entity_id)}
                                onChange={() => handleNewCheckboxChange(state.entity_id, 10)}
                              />
                            </div>
                          ))}
                        </div>
                      </>
                    )}

                    {showAssigned && (
                      <>
                        <div className="mt-3">
                          <MDBCheckbox checked={allNewAssigned} onChange={(e) => handleNewAllAssigned(e)} label="Select All" />
                        </div>
                        <div className="filtersScroll">
                          {displayNewFilterAssigned && displayNewFilterAssigned.map((assign) => (
                            <div className="" key={assign.entity_id}>
                              <MDBCheckbox name='flexCheck' value={assign.entity_id} id={assign.entity_id} label={assign.entity_name} checked={selectedNewAssignedIds.includes(assign.entity_id)}
                                onChange={() => handleNewCheckboxChange(assign.entity_id, 9)}
                              />
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                  </div>

                  {(showSMS || showLocation || showStates || showAssigned) ? (
                    <MDBModalFooter className="d-flex align-items-center justify-content-between pt-2 mt-2">
                      <MDBBtn size='sm' outline color='secondary' onClick={toggleBackClick} className="mx-0">
                        Back
                      </MDBBtn>
                      {((showAssigned && (selectedNewAssignedIds.length !== 0 && selectedNewAssignedIds.length !== assignedFilterList.length))
                        || (showSMS && (selectedNewSMSIds.length !== 0 && selectedNewSMSIds.length !== smsFilterList.length))
                        || (showLocation && (selectedNewLocationIds.length !== 0 && selectedNewLocationIds.length !== locationFilterList.length))
                        || (showStates && (selectedNewStatesIds.length !== 0 && selectedNewStatesIds.length !== stateFilterList.length))) && (
                          <div className="me-0">
                            <MDBBtn size='sm' color='secondary' className="me-2" onClick={(e) => {
                              if (showLocation) {
                                cancelFilterChanges(15);
                              } else if (showStates) {
                                cancelFilterChanges(16);
                              } else if (showSMS) {
                                cancelFilterChanges(17);
                              } else {
                                cancelFilterChanges(18);
                              }
                            }}>
                              cancel
                            </MDBBtn>
                            <MDBBtn size='sm' onClick={(e) => {
                              if (showSMS) {
                                handleSubmit(e, 8, selectedNewSMSIds);
                              } else if (showLocation) {
                                handleSubmit(e, 12, selectedNewLocationIds);
                              } else if (showStates) {
                                handleSubmit(e, 10, selectedNewStatesIds);
                              } else {
                                handleSubmit(e, 9, selectedNewAssignedIds);
                              }
                            }}>Apply</MDBBtn>
                          </div>
                        )}

                    </MDBModalFooter>
                  ) : null}
                </MDBPopconfirmMessage>
              </MDBPopconfirm>
            </div>
          )}
          {(selectedSMS || selectedLocation || selectedStates || selectedAssigned) && (
            <MDBBtn className="mx-2" onClick={removeallfilters}>Clear</MDBBtn>
          )}

        </div>
        <div className="d-flex align-items-center justify-content-between">
          <div className='mb-2 mt-0 position-relative ' style={{minWidth:"311px"}}>
            <MDBInput
              label="Search"
              ref={searchRef}
              value={searchValue}
              onChange={(e) => handleManualSearch(e.target.value)}
            />
            <MDBIcon fas icon="search" className='MDBDatatable-Search' />
          </div>
          <MDBBtnGroup aria-label="Button group with nested dropdown" className="display-inline btn_adjust h-inherit">
            <MDBBtnGroup>
              <MDBDropdown>
                <MDBDropdownToggle
                  className="px-3"
                  disabled={disableChangeLocation}
                >
                  <div className="text-white">
                    <MDBIcon fas icon="ellipsis-v" className="me-2" />
                    More
                  </div>
                </MDBDropdownToggle>
                <MDBDropdownMenu>
                  <MDBDropdownItem link onClick={(e) => { e.preventDefault(); toggleChangeLocation(); }}>
                    Change Location
                  </MDBDropdownItem>
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBBtnGroup>
          </MDBBtnGroup>
        </div>
        <MDBDatatable className="datatableSelect actioncolumn"
          onRowClick={(event) => {
            showThisInf(event);
          }}
          // search
          fixedHeader
          entries={50}
          key={searchValue}
          maxHeight="63vh" w-100 phonenumbersDatatable
          // multi
          // selectable
          sortField="Phone Number(s)"
          sortOrder="asc"
          searchInputProps={[]}
          data={{ ...basicData, rows: filteredRows }}
          responsive
          hover
        />
      </div>
      {unassignPHNum && (
        <PopupLoader
          title={"Unassign Phone Number"}
          content={<UnassignPhoneNumbers phoneNum={selectedPHNum} onClose={utogglePopup} isnineoo={nineoonum} />}
          onShow={SetUnassignPHNum}
          onClose={utogglePopup}
        />
      )}
      {showChangeLocation && (
        <PopupLoader
          title={"Change Location"}
          content={
            <PHChangeLocation
              onClose={toggleChangeLocation}
              phNumList={phNumList}
              sourceTab="tab1"
            />
          }
          onShow={setshowChangeLocation}
          onClose={toggleChangeLocation}
        />
      )}
      <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
        Unassign
      </Tooltip>
    </>
  );

}